import {
    EMPTY_CODE,
    EMPTY_MONEY,
    EMPTY_MULTIPLE,
    EMPTY_PERCENT,
    EMPTY_PERIOD,
    TraceableCode,
    TraceableMoney,
    TraceableMultiple,
    TraceablePercent,
    TraceablePeriod
} from "../../../shared/model/traceable";

export interface FinancialPerformanceRecord {
    id?: number;
    period: TraceablePeriod;
    currencyIso: TraceableCode;
    revenue: TraceableMoney;
    revenueGrowth: TraceablePercent;
    debtRepaymentCapacity: TraceablePercent;
    netDebt: TraceableMoney;
    enterpriseValue: TraceableMoney;
    commonEquity: TraceableMoney;
    ebt: TraceableMoney;
    ebtMargin: TraceablePercent;
    ebtGrowth: TraceablePercent;
    ebit: TraceableMoney;
    ebitMargin: TraceablePercent;
    ebitGrowth: TraceablePercent;
    ebita: TraceableMoney;
    ebitaMargin: TraceablePercent;
    ebitaGrowth: TraceablePercent;
    ebitda: TraceableMoney;
    ebitdaMargin: TraceablePercent;
    ebitdaGrowth: TraceablePercent;
    ebitdar: TraceableMoney;
    ebitdarMargin: TraceablePercent;
    ebitdarGrowth: TraceablePercent;
    priceOverEarningsMultiple: TraceableMultiple;
    enterpriseValueOverEbitMultiple: TraceableMultiple;
    enterpriseValueOverEbitaMultiple: TraceableMultiple;
    enterpriseValueOverEbitdaMultiple: TraceableMultiple;
    enterpriseValueOverEbitdarMultiple: TraceableMultiple;
    enterpriseValueOverRevenueMultiple: TraceableMultiple;
    forecast: boolean;
    gpProjected: boolean;
}

export const EMPTY_FINANCIAL_PERFORMANCE_RECORD: FinancialPerformanceRecord = {
    id: undefined,
    period: EMPTY_PERIOD,
    currencyIso: EMPTY_CODE,
    revenue: EMPTY_MONEY,
    revenueGrowth: EMPTY_PERCENT,
    debtRepaymentCapacity: EMPTY_PERCENT,
    netDebt: EMPTY_MONEY,
    enterpriseValue: EMPTY_MONEY,
    commonEquity: EMPTY_MONEY,
    ebt: EMPTY_MONEY,
    ebtMargin: EMPTY_PERCENT,
    ebtGrowth: EMPTY_PERCENT,
    ebit: EMPTY_MONEY,
    ebitMargin: EMPTY_PERCENT,
    ebitGrowth: EMPTY_PERCENT,
    ebita: EMPTY_MONEY,
    ebitaMargin: EMPTY_PERCENT,
    ebitaGrowth: EMPTY_PERCENT,
    ebitda: EMPTY_MONEY,
    ebitdaMargin: EMPTY_PERCENT,
    ebitdaGrowth: EMPTY_PERCENT,
    ebitdar: EMPTY_MONEY,
    ebitdarMargin: EMPTY_PERCENT,
    ebitdarGrowth: EMPTY_PERCENT,
    priceOverEarningsMultiple: EMPTY_MULTIPLE,
    enterpriseValueOverEbitMultiple: EMPTY_MULTIPLE,
    enterpriseValueOverEbitaMultiple: EMPTY_MULTIPLE,
    enterpriseValueOverEbitdaMultiple: EMPTY_MULTIPLE,
    enterpriseValueOverEbitdarMultiple: EMPTY_MULTIPLE,
    enterpriseValueOverRevenueMultiple: EMPTY_MULTIPLE,
    forecast: false,
    gpProjected: false
};
